import BaseService from "./BaseService";
import {ROOT, REPORT} from "./_base";

class ReportService extends BaseService {

    async initReport(params) {
        const response = await this.get(`${ROOT}/${REPORT}/init-report`, params);
        return response.data
    }

    async getDefaultDate(params) {
        const response = await this.get(`${ROOT}/${REPORT}/get-default-date`, params);
        return response.data
    }

    async searchPeriodReport(config) {
        const response = await this.get(`${ROOT}/${REPORT}/period-report`, config);
        return response.data
    }

    async verifyDownload(config) {
        let params = config.params;
        const response = await this.postByUri(`${ROOT}/${REPORT}/download-report?link=` + params.link + "&accountType=" + params.accountType + "&reportId=" + params.reportId + "&reportDate=" + params.reportDate +"&fileType=.pdf");
        return response.data
    }
}

export default ReportService;
